export default "__VITE_ASSET__BWUOPsL$__"